/* RESPONSIBLE TEAM: team-actions */

export default class CommandsResolver {
  actions;
  tags;
  teammates;
  teams;
  defaultTeam;

  constructor(options: any) {
    let { actions, tags, teammates, teams, defaultTeamHeader } = Object.assign({}, options);
    this.actions = this.generateInlineAttributes(actions, 'workflow_connector', 'data-connectors');
    this.tags = this.generateInlineAttributes(tags, 'tag', 'tag');
    this.teammates = this.generateInlineAttributes(
      teammates.list,
      'assignee',
      'assignment',
      teammates.header,
    );
    this.teams = this.generateInlineAttributes(teams.list, 'assignee', 'team', teams.header);
    this.defaultTeam = this.buildDefaultTeam(defaultTeamHeader);
  }

  buildDefaultTeam(defaultTeamHeader: string) {
    return {
      attributes: [
        {
          icon: 'team',
          identifier: 'assignee.DEFAULT',
          name: defaultTeamHeader,
        },
      ],
      showDescription: true,
    };
  }

  generateInlineAttributes(list: any[], operation: string, icon: string, header?: string) {
    return {
      heading: header,
      attributes: list.map((listItem: any) => {
        return {
          icon,
          identifier: `${operation}.${listItem.id}`,
          name: listItem.name,
          object: listItem,
        };
      }),
    };
  }

  private findAttribute(identifier: string) {
    let allAttributes = [
      ...this.tags.attributes,
      ...this.actions.attributes,
      ...this.teammates.attributes,
      ...this.teams.attributes,
      ...this.defaultTeam.attributes,
    ];
    return allAttributes?.findBy('identifier', identifier);
  }

  public humanReadable(identifier: string) {
    return this.findAttribute(identifier)?.name || identifier;
  }
}
